import React from 'react';
import { ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import { Button, TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import { StatusChipWithTooltip } from '~/modules/guarantees/legacy/StatusChipWithTooltip.tsx';
import { dataFormStyles, covConstantsStyles } from '~/modules/guarantees/legacy/styles.ts';
import { guaranteesApplicationStatusStyles } from '~/modules/guarantees/form/application/shared/components/guaranteesApplicationStatusStyles.ts';
import { guaranteesApplicationStatusConfig, guaranteesClientText } from '../../constants.ts';
import { formatGuaranteesDate } from '../../formatters.ts';
import { guaranteesClientPageStyles } from '../../styles.ts';
import type { IApplicationsTableRowProps } from './types.ts';

const ApplicationsTableRow: React.FC<IApplicationsTableRowProps> = ({
  application,
  onOpenApplication,
}) => {
  const statusConfig = guaranteesApplicationStatusConfig[application.status];
  const applicationNumber = (
    <Typography variant="body2" sx={guaranteesClientPageStyles.applicationNumberText}>
      {application.applicationNumber}
    </Typography>
  );

  return (
    <TableRow hover sx={dataFormStyles.documentTableRow}>
      <TableCell sx={(theme) => dataFormStyles.documentTableBodyCell(theme, 'name')}>
        {application.isTemporaryApplicationNumber ? (
          <Tooltip title={guaranteesClientText.temporaryApplicationNumberTooltip}>
            {applicationNumber}
          </Tooltip>
        ) : (
          applicationNumber
        )}
      </TableCell>
      <TableCell
        align="center"
        sx={(theme) => dataFormStyles.documentTableBodyCell(theme, 'createdAt')}
      >
        <Typography variant="body2" sx={covConstantsStyles.tableDateText}>
          {formatGuaranteesDate(application.createdAt)}
        </Typography>
      </TableCell>
      <TableCell
        align="center"
        sx={(theme) => dataFormStyles.documentTableBodyCell(theme, 'status')}
      >
        <StatusChipWithTooltip
          label={statusConfig.label}
          color={statusConfig.color}
          description={statusConfig.description}
          chipSx={guaranteesApplicationStatusStyles.chip}
        />
      </TableCell>
      <TableCell
        align="center"
        sx={(theme) => dataFormStyles.documentTableBodyCell(theme, 'actions')}
      >
        <Button
          variant="outlined"
          size="small"
          endIcon={<ArrowForwardIcon />}
          onClick={() => onOpenApplication(application)}
          sx={covConstantsStyles.covBtn}
        >
          {guaranteesClientText.openApplicationButton}
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default ApplicationsTableRow;
